import { MarketplaceId } from '@rome/request/marketplace/MarketplaceId';
import ApiCaller from '../ApiCaller';
import baseAjaxConfig from '../BaseAjaxConfig';
import { CartView } from '@rome/request/cart/v5/CartView';
/*****************************/
// Remove action
/****************************/
export var REMOVE_FROM_CART;
(function (REMOVE_FROM_CART) {
    REMOVE_FROM_CART["REQUEST"] = "REMOVE_FROM_CART_REQUEST";
    REMOVE_FROM_CART["SUCCESS"] = "REMOVE_FROM_CART_SUCCESS";
    REMOVE_FROM_CART["ERROR"] = "REMOVE_FROM_CART_ERROR";
})(REMOVE_FROM_CART || (REMOVE_FROM_CART = {}));
export var REMOVE_FROM_BASKET;
(function (REMOVE_FROM_BASKET) {
    REMOVE_FROM_BASKET["REQUEST"] = "REMOVE_FROM_BASKET_REQUEST";
    REMOVE_FROM_BASKET["SUCCESS"] = "REMOVE_FROM_BASKET_SUCCESS";
    REMOVE_FROM_BASKET["ERROR"] = "REMOVE_FROM_BASKET_ERROR";
})(REMOVE_FROM_BASKET || (REMOVE_FROM_BASKET = {}));
function removeActionFactory(requestAction, successAction, errorAction, view) {
    return function (listingIds = [], isMarketPlace = false) {
        return (dispatch) => {
            if (!isMarketPlace && !listingIds.length) {
                return dispatch({
                    type: REMOVE_FROM_BASKET.ERROR,
                    error: { errorMessage: 'listingIds are empty' }
                });
            }
            const query = isMarketPlace
                ? { marketplaceIds: MarketplaceId.GROCERY, view }
                : { listingIds: listingIds.join(','), view };
            dispatch({
                type: requestAction
            });
            return ApiCaller.delete(Object.assign({}, baseAjaxConfig, {
                pathname: '/api/5/cart',
                acceptErrors: true,
                action: REMOVE_FROM_CART.REQUEST,
                query
            }))
                .then(data => {
                dispatch({
                    type: successAction,
                    data: data.RESPONSE
                });
                return data;
            })
                .catch(err => {
                dispatch({
                    type: errorAction,
                    error: err
                });
                return Promise.reject(err);
            });
        };
    };
}
export const removeFromCartAction = removeActionFactory(REMOVE_FROM_CART.REQUEST, REMOVE_FROM_CART.SUCCESS, REMOVE_FROM_CART.ERROR, CartView.ALL);
export const removeFromBasketAction = removeActionFactory(REMOVE_FROM_BASKET.REQUEST, REMOVE_FROM_BASKET.SUCCESS, REMOVE_FROM_BASKET.ERROR, CartView.GROCERY);
/**********************************/
// Undo delete
/**********************************/
export var UNDO_DELETE_FROM_CART;
(function (UNDO_DELETE_FROM_CART) {
    UNDO_DELETE_FROM_CART["REQUEST"] = "UNDO_DELETE_FROM_CART_REQUEST";
    UNDO_DELETE_FROM_CART["SUCCESS"] = "UNDO_DELETE_FROM_CART_SUCCESS";
    UNDO_DELETE_FROM_CART["ERROR"] = "UNDO_DELETE_FROM_CART_ERROR";
})(UNDO_DELETE_FROM_CART || (UNDO_DELETE_FROM_CART = {}));
export var UNDO_DELETE_FROM_BASKET;
(function (UNDO_DELETE_FROM_BASKET) {
    UNDO_DELETE_FROM_BASKET["REQUEST"] = "UNDO_DELETE_FROM_BASKET_REQUEST";
    UNDO_DELETE_FROM_BASKET["SUCCESS"] = "UNDO_DELETE_FROM_BASKET_SUCCESS";
    UNDO_DELETE_FROM_BASKET["ERROR"] = "UNDO_DELETE_FROM_BASKET_ERROR";
})(UNDO_DELETE_FROM_BASKET || (UNDO_DELETE_FROM_BASKET = {}));
function undoDeleteActionFactory(requestAction, successAction, errorAction, view = CartView.ALL) {
    return function undoDelete(listingIds = []) {
        return (dispatch) => {
            if (!listingIds.length) {
                return dispatch({
                    type: errorAction
                });
            }
            let cartContext = listingIds.reduce((p, listingId) => Object.assign(p, {
                [listingId]: {
                    quantity: 1
                }
            }), {});
            dispatch({
                type: requestAction
            });
            return ApiCaller.put(Object.assign({}, baseAjaxConfig, {
                pathname: `/api/5/cart`,
                acceptErrors: true,
                action: requestAction,
                query: { source: 'UNDO_DELETE', view }
            }), { cartContext })
                .then(data => {
                dispatch({
                    type: successAction,
                    data: data.RESPONSE
                });
                return data;
            })
                .catch(err => {
                dispatch({
                    type: errorAction,
                    error: err
                });
                return Promise.reject(err);
            });
        };
    };
}
export const undoDeleteInCartAction = undoDeleteActionFactory(UNDO_DELETE_FROM_CART.REQUEST, UNDO_DELETE_FROM_CART.SUCCESS, UNDO_DELETE_FROM_CART.ERROR, CartView.ALL);
export const undoDeleteInBasketAction = undoDeleteActionFactory(UNDO_DELETE_FROM_BASKET.REQUEST, UNDO_DELETE_FROM_BASKET.SUCCESS, UNDO_DELETE_FROM_BASKET.ERROR, CartView.GROCERY);
/************************/
// CHANGE QUANTITY
/************************/
export var CHANGE_QUANTITY_IN_CART;
(function (CHANGE_QUANTITY_IN_CART) {
    CHANGE_QUANTITY_IN_CART["REQUEST"] = "CHANGE_QUANTITY_IN_CART_REQUEST";
    CHANGE_QUANTITY_IN_CART["SUCCESS"] = "CHANGE_QUANTITY_IN_CART_SUCCESS";
    CHANGE_QUANTITY_IN_CART["ERROR"] = "CHANGE_QUANTITY_IN_CART_ERROR";
})(CHANGE_QUANTITY_IN_CART || (CHANGE_QUANTITY_IN_CART = {}));
export var CHANGE_QUANTITY_IN_BASKET;
(function (CHANGE_QUANTITY_IN_BASKET) {
    CHANGE_QUANTITY_IN_BASKET["REQUEST"] = "CHANGE_QUANTITY_IN_BASKET_REQUEST";
    CHANGE_QUANTITY_IN_BASKET["SUCCESS"] = "CHANGE_QUANTITY_IN_BASKET_SUCCESS";
    CHANGE_QUANTITY_IN_BASKET["ERROR"] = "CHANGE_QUANTITY_IN_BASKET_ERROR";
})(CHANGE_QUANTITY_IN_BASKET || (CHANGE_QUANTITY_IN_BASKET = {}));
function changeQuantityFactory(requestAction, successAction, errorAction, view = CartView.ALL) {
    return function changeQuantity(listingId, quantity) {
        return (dispatch) => {
            if (!listingId) {
                dispatch({
                    type: errorAction,
                    error: { errorMessage: 'Listing id is empty' }
                });
                return Promise.reject('');
            }
            const requestPayload = {
                cartContext: {
                    [listingId]: {
                        quantity
                    }
                }
            };
            dispatch({
                type: requestAction
            });
            return ApiCaller.put(Object.assign({}, baseAjaxConfig, {
                pathname: `/api/5/cart`,
                acceptErrors: true,
                action: requestAction,
                query: { view }
            }), requestPayload)
                .then(data => {
                dispatch({
                    type: successAction,
                    data: data.RESPONSE
                });
            })
                .catch(err => {
                dispatch(Object.assign(Object.assign({ type: errorAction }, err), { errorMessage: err.ERROR_MESSAGE }));
                return Promise.reject(err);
            });
        };
    };
}
export const changeQuantityInCartAction = changeQuantityFactory(CHANGE_QUANTITY_IN_CART.REQUEST, CHANGE_QUANTITY_IN_CART.SUCCESS, CHANGE_QUANTITY_IN_CART.ERROR, CartView.ALL);
export const changeQuantityBasketAction = changeQuantityFactory(CHANGE_QUANTITY_IN_BASKET.REQUEST, CHANGE_QUANTITY_IN_BASKET.SUCCESS, CHANGE_QUANTITY_IN_BASKET.ERROR, CartView.GROCERY);
